import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import Overlay, { StopPropagation } from '@ynap/overlay';

const bem = new BEMHelper('LoginAndRegistrationModal');

type LoginAndRegistrationModalProps = {
    iframeHeight: number;
    signInIframeUrl: string;
    onCloseModal: () => void;
};

const LoginAndRegistrationModal = ({ iframeHeight, signInIframeUrl, onCloseModal }: LoginAndRegistrationModalProps) => {
    const pathToAccount = signInIframeUrl.startsWith('/') ? `${window.location.origin}${signInIframeUrl}` : signInIframeUrl;

    return (
        <StopPropagation>
            <Overlay
                onClose={onCloseModal}
                handleBodyClick={onCloseModal}
                title=" "
                className={{ container: bem('loginModal'), title: bem('signInOverlayTitle'), button: bem('signInOverlayClose') }}
            >
                <iframe className={bem('iframe')} src={pathToAccount} height={iframeHeight} />
            </Overlay>
        </StopPropagation>
    );
};

export default LoginAndRegistrationModal;
